import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { observer } from "mobx-react";
import { Image, Icon } from "semantic-ui-react";
import DnDItem from "~/components/element/DnDItem";
import MediaItem from "~/models/Media/MediaItem";

const FlyerMediaItem = observer(({ mediaItem, source, centered, onDragEnd }) => {
  // "selected" as in from the bucket.
  // if the current mediaItem is from the bucket, and it's selected we'll display it with opacity
  // and a check icon.
  const selectedInBucket = mediaItem.isSelected && source === "bucket";

  return (
    <DnDItem
      id={mediaItem.mediaItemId}
      key={mediaItem.mediaItemId}
      className={cx("ui card", {
        draggable: !(mediaItem.isSlot || selectedInBucket),
        slot: mediaItem.isSlot,
        selected: selectedInBucket,
        centered,
      })}
      onDragEnd={(sourceItem, targetItem) => onDragEnd(sourceItem, targetItem)}
      item={{
        id: mediaItem.mediaItemId,
        type: mediaItem.isSlot ? "slot" : "media",
        accept: "media",
        source,
      }}
      canDrag={() => {
        if (mediaItem.isSlot) {
          return false;
        }

        return !selectedInBucket;
      }}
    >
      <Image className={cx({ slot: mediaItem.isSlot })} src={mediaItem.thumbnailLarge} wrapped ui={false} />
      {selectedInBucket && <Icon name="check" />}
    </DnDItem>
  );
});

FlyerMediaItem.propTypes = {
  mediaItem: PropTypes.instanceOf(MediaItem).isRequired,
  source: PropTypes.oneOf(["bucket", "template"]),
  centered: PropTypes.bool,
  onDragEnd: PropTypes.func.isRequired,
};

export default FlyerMediaItem;
